<mat-form-field [ngClass]="['d-block']" appearance="outline">
  <mat-label>{{ 'forms:' + field.label | i18nextCap }}</mat-label>

  <mat-select
    [formControl]="formControl"
    (selectionChange)="onSelectChange($event)"
    [multiple]="multiple"
    (closed)="onClose($event)"
    [attr.data-testid]="this.field.dataTestId"
    (ngModelChange)="modelChange($event)"
    [matTooltip]="getTooltip(field.matTooltip) | async"
    [matTooltipDisabled]="
      !field.matTooltip || !(getTooltip(field.matTooltip) | async)
    "
    matTooltipPosition="right"
    matTooltipPosition="right"
    disableOptionCentering
  >
    @if (selected) {
      <mat-select-trigger>
        @if (selected.icon) {
          <mat-icon [ngClass]="['icon', 'color-' + selected.color]"
            >{{ selected.icon }}
          </mat-icon>
        }
        @if (selected.image) {
          <img [attr.alt]="selected.name" [src]="selected.image" />
        }
        <span class="selected">
          @if (field.translate) {
            {{ 'forms:' + selected.name | i18nextCap }}
          }
          @if (!field.translate) {
            {{ selected.name }}
          }
        </span>
      </mat-select-trigger>
    }

    @if (field.nullable) {
      <mat-option value="" #unassign (click)="toggleUnassigned()">
        {{ 'forms:unassign' | i18nextCap }}
      </mat-option>
    }
    @if (field.items$ | async; as items) {
      @for (item of items; track item) {
        @if (
          field.select?.onlyActiveOption && item.active == false ? false : true
        ) {
          <mat-option [value]="item.id" (click)="tosslePerOne()">
            @if (item.icon) {
              <mat-icon [ngClass]="['icon', 'color-' + item.color]"
                >{{ item.icon }}
              </mat-icon>
            }
            @if (item.image) {
              <img [attr.alt]="item.name" [src]="item.image" />
            }
            @if (field.translate) {
              {{
                'forms:' +
                  (field.displayValue ? field.displayValue(item) : item.name)
                  | i18nextCap
              }}
            }
            @if (!field.translate) {
              {{ field.displayValue ? field.displayValue(item) : item.name }}
            }
          </mat-option>
        }
      }
    }
  </mat-select>
  <mat-error>{{ 'validation:youMustSelectAnOption' | i18nextCap }}</mat-error>
</mat-form-field>
